import { Component, OnInit } from '@angular/core';
import { WorkingDaysService } from './working-days.service';
import { workingDaysScope } from '../../models/lookups/workingDays.model';
import { AlertService, DialogType } from '../../services/alert.service';
import { AccountService } from '../../services/account.service';
import { Permission } from '../../models/permission.model';
import { BusinessUnitService } from '../business-unit/business-unit.service';
import { BusinessUnit } from '../../models/lookups/business-unit.model';

// Working days of the company (no business unit picked) or of one business unit and its sub-units.
@Component({
  selector: 'working-days',
  templateUrl: './working-days.component.html',
  styleUrls: ['./working-days.component.css']
})
export class WorkingDaysComponent implements OnInit {
  businessUnits: BusinessUnit[] = [];
  selectedBusinessUnit: BusinessUnit;
  public logo = require("../../../app/assets/images/demo/Icon_Working Days.png");

  constructor(private alertService: AlertService,
    private workingDaysService: WorkingDaysService,
    private businessUnitService: BusinessUnitService,
    private accountService: AccountService) { }

  ngOnInit() {
    this.businessUnitService.getAllBusinessUnits().subscribe(response => {
      this.businessUnits = (response as BusinessUnit[]).filter(b => b.active !== false);
    }, () => { });
  }

  get canManage() {
    return this.accountService.userHasPermission(Permission.manageWorkingDaysPermission);
  }

  get businessUnitId(): number {
    return this.selectedBusinessUnit ? this.selectedBusinessUnit.id : null;
  }

  // after a business unit's days change, tell the admin which business units still have no business-unit days
  onChanged(scope: workingDaysScope) {
    if (!scope.businessUnitId)
      return;
    this.workingDaysService.GetUncoveredBusinessUnits().subscribe((names: string[]) => {
      if (names && names.length)
        this.alertService.showDialog(
          `These business units are not covered by business-unit working days and follow the company default:\n${names.join(', ')}`,
          DialogType.Alert, () => { }, null, "OK");
    }, () => { });
  }
}
